import { createContext, useState } from "react";

import LabTable from "./components/LabTable";
import { InvestigationFormType, LabTableType } from "../types";


export type contextType={
    tableData:LabTableType[],
    setTableData:(params:LabTableType[])=>void
    edit:InvestigationFormType|null;
    setEdit:(params:any)=>void;
    setRefetchLab:(params:boolean)=>void;
    refetchLab:boolean
 }

    export const LabContext=createContext<contextType|null>({edit:null,setEdit:()=>{},tableData:[],setTableData:()=>{},refetchLab:true,setRefetchLab:()=>{}})


function LabComponent() {
    const [tableData,setTableData]=useState<LabTableType[]>([])
    const [edit,setEdit] = useState<InvestigationFormType | null>(null)
    const [refetchLab,setRefetchLab] = useState<boolean>(true)
  return (
    <LabContext.Provider value={{tableData,setTableData,edit,setEdit,refetchLab,setRefetchLab}} >
        <LabTable/>
    </LabContext.Provider>
  )
}

export default LabComponent
